import { EnvironmentName } from "../constants";
import { getClientConfiguration } from "./configurationHelper";

export const isEnvironment = (environmentName: EnvironmentName) => {
  return getClientConfiguration().environmentName === environmentName;
};
